<script setup>
  import { ContentLoader } from 'vue-content-loader';
</script>

<template>
  <div
    class="lazy-loading-table"
  >
    <ContentLoader
      :height="400"
      :speed="2"
      :width="990"
      primary-color="#f3f3f3"
      secondary-color="#ecebeb"
    >
      <rect
        height="30"
        rx="4"
        ry="4"
        width="990"
        x="0"
        y="0"
      />
      <rect
        height="15"
        rx="4"
        ry="4"
        width="990"
        x="0"
        y="35"
      />
      <rect
        height="15"
        rx="4"
        ry="4"
        width="990"
        x="0"
        y="60"
      />
      <rect
        height="15"
        rx="4"
        ry="4"
        width="990"
        x="0"
        y="85"
      />
      <rect
        height="15"
        rx="4"
        ry="4"
        width="990"
        x="0"
        y="110"
      />
      <rect
        height="15"
        rx="4"
        ry="4"
        width="990"
        x="0"
        y="135"
      />
    </ContentLoader>
  </div>
</template>

<style lang="scss">
.lazy-loading-table {
  position: relative;
  svg {
    width: 100%;
    height: auto;
  }
}
</style>
